import {Utils} from "../libs/utils";


export class LocationDto {
    public address?: string;
    public country?: string;
    public postalCode?: string;
    public city?: string;
    public latitude?: number;
    public longitude?: number;

    public static getAddressString(location: LocationDto): string {
        if (typeof location === 'undefined' || !location) {
            return null;
        }
        var locationString = "";
        if (!Utils.isStringEmpty(location.address)) {
            locationString += location.address + ", "
        }
        if (!Utils.isStringEmpty(location.postalCode)) {
            locationString += location.postalCode + " "
        }
        if (!Utils.isStringEmpty(location.city)) {
            locationString += location.city + " "
        }
        return locationString

    }
}